import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { APP_TYPE, formatDate } from "../../config/Config";
import DocumentTypesService from "../../services/DocumentsService";
import { helper } from "../../componets/utils/helper";
import { candidateService } from "../../services/CandidateService";
import ScreenLoader from "../../componets/ScreenLoader";
import { AppDB } from "../../App";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import GenericFileCapture from "../../componets/GenericFileCapture";

export default function ({ showAddDialog, setShowAddDialog, header = "Proportional Candidates Documents ", delimitation, setDelimitation }) {
	var { selectedParty } = useContext(PoliticalPartyDBContext);
	var { lookUp } = useContext(AppDB);
	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
	var [loading, setLoading] = useState(false);
	var [refresh, setRefresh] = useState(true);
	var [documents, setDocuments] = useState([]);

	var political = new PoliticalPartyService();
	var doc = new DocumentTypesService();

	useEffect(() => {
		if (showAddDialog?.event?.eventID) {
			setLoading(true);
			political.getAllPolitical_proportional_candidates_documents(selectedParty.politicalPartyID, showAddDialog?.event?.eventID).then((res) => {
				setDocuments(res);
				setLoading(false);
			});
		}
	}, [refresh, showAddDialog]);
	var convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	return (
		<>
			<ScreenLoader visible={loading} />

			{APP_TYPE !== "PoliticalParty" && (
				<div className="card">
					<div className="col-12  lg:col-3 my-2">
						<>
							<Button
								disabled={[null, undefined, ""].includes(showAddDialog.event?.eventID)}
								label={"Upload"}
								onClick={() => setShowFileUploader(true)}
								className="p-button-success"
								icon={"pi pi-plus"}
							/>
						</>
					</div>
				</div>
			)}

			<GenericFileCapture
				refresh={refresh}
				setRefresh={setRefresh}
				requestCall={political.add_proportional_upload_documents}
				key={JSON.stringify(showAddDialog) + JSON.stringify(JSON.stringify(showAddDialog))}
				extraAttributes={{
					politicalPartyID: selectedParty?.politicalPartyID,
					eventID: showAddDialog.event?.eventID
				}}
				documentTypesLookUp={lookUp?.documentTypes}
				show={showFileUploader}
				setShow={setShowFileUploader}
				setDocuments={setFileUploaderDocuments}
				documents={fileUploaderDocuments}
			/>

			<DataTable
				className="remove-border"
				size="small"
				scrollable={true}
				value={documents}
				dataKey="id"
				loading={loading}
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column header={"Title"} field="title"></Column>
				<Column header={"Document Type"} field="documentType"></Column>
				<Column header={"Created Date"} body={(row) => formatDate(row.createdDate)}></Column>
				<Column
					header={"Action"}
					field="Action"
					body={(row) => (
						<Button
							style={{
								textAlign: "center",
								width: "30px",
								height: "30px"
							}}
							icon={"pi pi-download"}
							tooltipOptions={{ position: "top" }}
							className="p-button-primary p-button-rounded mr-2"
							tooltip="Click to download"
							onClick={(e) => {
								e.stopPropagation();
								setLoading(true);
								doc.downloadDocument(row.documentID).then((res) => {
									setLoading(false);
								});
							}}
						/>
					)}
				></Column>
			</DataTable>
		</>
	);
}
